import { map } from "./map";
export const act = <T>(f: (t: T) => void) => map((x: T) => {
  f(x);
  return x;
});

export const tap = act;
